import { Navigate } from "react-router-dom";

const ProtectedRoute = ({ user, access, name, children }) => {

    const dirWebApp = process.env.REACT_APP_DIR_PRO
  
    if (!user) {
        return <Navigate to={`${dirWebApp}login`} replace />
    }
    else if (user && !access) {
        return <Navigate to={`${dirWebApp}disclaimer`} replace />
    } else {
        return children
    }

}

export default ProtectedRoute